const accordion =  (props = {})=>({
    openAccordions: [],
    index: 0,
    showMore: false,
    init(){
        const { isOpen, isFirstOpen, blockId, group } = props
        if (blockId && (isOpen || isFirstOpen)) {
            this.index = this.openAccordions.indexOf(blockId);
            if (this.index === -1) {
                this.openAccordions.push(blockId)
            }
        }

        if (group) {
            window.addEventListener('psn:accordion-opened', (e) => {
                if (e.detail.group === group && String(e.detail.id) !== String(blockId)) {
                    this.openAccordions = [];
                    this.showMore = false;
                }
            })
        }
    },
    toggleAccordionVideo(event) {
        const videoContainer = event.target.closest('.media-wrapper').querySelector('.accordion__video')

        if (videoContainer.paused) {
            videoContainer.play()
            event.target.innerText = 'Pause'
        } else {
            videoContainer.pause()
            event.target.innerText = 'Play'
        }
    },
    toggleAccordion(accordionNumber) {
        this.index = this.openAccordions.indexOf(accordionNumber);

        if (this.index === -1) {
            this.openAccordions.push(accordionNumber);

            if (props.group) {
                window.dispatchEvent(new CustomEvent('psn:accordion-opened', {
                    detail: {
                        id: accordionNumber,
                        group: props.group
                    }
                }))
            }
        } else {
            this.openAccordions.splice(this.index, 1);
        }
    },
    showMoreShowLess(){
        this.showMore = !this.showMore
    }
})

export default accordion()

window.addEventListener("alpine:init", ()=>{
    Alpine.data("accordion", accordion)
})
